import React from 'react';
import * as Images from 'pos/Images';

import { HStack, VStack, Box, Table, Text } from '@chakra-ui/react';
import { ProductForSaleDTO, Res } from 'core/api';
import { Info } from 'core/img';
import { Format } from 'core/ui';
import { SvgIcon } from 'core/ui-next';


enum SortMode {
	SaleFormatName,
	Family,
	Barcode,
	Price
}

type TableProps = {
	products: ProductForSaleDTO[];
	maxResults: number;
	sortMode?: SortMode;
	onProductSelected: (product: ProductForSaleDTO) => void;
	onSortBy: (sortMode: SortMode) => void;
	onShowDetails: (product: ProductForSaleDTO) => Promise<Result<unknown, unknown>>;
};


export function SearchProductByTextPhoneTable(props: TableProps) {

	const { products, maxResults, sortMode, onProductSelected, onSortBy, onShowDetails } = props;

	// Asumo que si me han llegado tantos productos como el máximo posible, es que puede haber más resultados.
	// Dejo fuera el caso en que existieran _exactamente_ ese número de productos. Creo que es asumible.
	const maxResultsReached = products.length >= maxResults;


	return <Table.ScrollArea w={'full'} maxH={'82'} rounded={'md'}>
		<Table.Root striped interactive stickyHeader>
			<Table.Header>
				<Table.Row>
					<Table.ColumnHeader w={'46'} minW={'46'} maxW={'46'} onClick={() => onSortBy(SortMode.SaleFormatName)} cursor={'pointer'}>
						<HStack gap={'0.5'} justifyContent={'start'}>
							<Text fontSize={'sm'} fontWeight={'semibold'}>{Res.Web.SEARCH_PRODUCT_BY_TEXT_PRODUCT_CLM()}</Text>
							{sortMode === SortMode.SaleFormatName && <SvgIcon src={Images.SortByAsc} width={'4'} height={'4'} />}
						</HStack>
					</Table.ColumnHeader>
					<Table.ColumnHeader w={'22'} minW={'22'} maxW={'22'} onClick={() => onSortBy(SortMode.Price)} cursor={'pointer'}>
						<HStack gap={'0.5'} justifyContent={'end'}>
							<Text fontSize={'sm'} fontWeight={'semibold'}>{Res.Web.SEARCH_PRODUCT_BY_TEXT_PRICE_CLM()}</Text>
							{sortMode === SortMode.Price && <SvgIcon src={Images.SortByAsc} width={'4'} height={'4'} />}
						</HStack>
					</Table.ColumnHeader>
					<Table.ColumnHeader w={'10'} minW={'10'} maxW={'10'}>
						<Text><></></Text>
					</Table.ColumnHeader>
				</Table.Row>
				{maxResultsReached &&
					<Table.Row h={'full'} top={'11.25'}>
						<Table.ColumnHeader colSpan={4} bg={'warning'}>
							<HStack w={'full'} minH={'5'} gap={'0.5'} justifyContent={'center'}>
								<Text fontSize={'sm'}>{Res.Msg.MSG_MAX_SEARCH_TEXT_RESULT_REACHED(maxResults)}</Text>
							</HStack>
						</Table.ColumnHeader>
					</Table.Row>
				}
			</Table.Header>
			<Table.Body>
				{products.map((product, index) => {

					const hasPLU = Boolean(product.PriceLookUpCode && product.PriceLookUpCode.length > 0);
					const hasBarcode = Boolean(product.Barcode && product.Barcode.length > 0);
					const hasFamily = Boolean(product.FamilyName && product.FamilyName.length > 0);

					const hasSecondLevel = hasPLU || hasBarcode || hasFamily;
					const hasThirdLevel = hasPLU && hasBarcode;

					const secondLevelCode = hasPLU
						? Res.Web.SEARCH_PRODUCT_BY_TEXT_PLU_CLM() + ' ' + product.PriceLookUpCode
						: hasBarcode
							? Res.Web.SEARCH_PRODUCT_BY_TEXT_BARCODE_CLM() + ' ' + product.Barcode
							: '';

					return <Table.Row key={index} h={'full'} cursor={'pointer'}>
						<Table.Cell w={'46'} minW={'46'} maxW={'46'} onClick={() => onProductSelected(product)}>
							<VStack gap={'1'} alignItems={'stretch'} justifyContent={'start'} w={'full'}>
								<Box><Text fontSize={'sm'} lineClamp={1}>{product.SaleFormatName}</Text></Box>
								{hasSecondLevel &&
									<HStack w={'full'} minH={'5'} gap={'0.5'}>
										<Text fontSize={'xs'} color={{ base: 'neutral.500', _dark: 'neutral.400' }} lineClamp={1}>{secondLevelCode}</Text>
									</HStack>}
								{hasThirdLevel &&
									<HStack w={'full'} minH={'5'} gap={'0.5'}>
										<Text fontSize={'xs'} color={{ base: 'neutral.500', _dark: 'neutral.400' }} lineClamp={1}>{Res.Web.SEARCH_PRODUCT_BY_TEXT_BARCODE_CLM() + ' ' + product.Barcode}</Text>
									</HStack>
								}
							</VStack>
						</Table.Cell>
						<Table.Cell w={'22'} minW={'22'} maxW={'22'} onClick={() => onProductSelected(product)}>
							<HStack w={'full'} minH={'5'} gap={'0.5'} textAlign={'end'} justifyContent={'end'}>
								<Text fontSize={'sm'} lineClamp={1}>{Format.asMoney(product.Price)}</Text>
							</HStack>
							{hasSecondLevel &&
								<HStack w={'full'} minH={'5'} gap={'0.5'} textAlign={'start'}>
									<Text fontSize={'sm'} lineClamp={1}>{hasFamily ? product.FamilyName : ''}</Text>
								</HStack>
							}
							{hasThirdLevel &&
								<HStack w={'full'} minH={'5'} gap={'0.5'} textAlign={'end'} justifyContent={'end'}>
									<></>
								</HStack>
							}
						</Table.Cell>
						<Table.Cell w={'10'} minW={'10'} maxW={'10'}><SvgIcon src={Info} width={'4'} height={'4'} color={{ base: 'blue.700', _dark: 'white' }} cursor={'pointer'} onClick={() => onShowDetails(product)} /></Table.Cell>
					</Table.Row>;
				})}
			</Table.Body>
		</Table.Root>
	</Table.ScrollArea >;
}
